import useRequest from '@/websdk/utils/request';
import { useEffect } from 'react';

export default (function (param) {
  const { data, exec, isRequestSuccessed } = useRequest({
    name: 'GET_WORK_LINES',
    url: '',
  });

  const manualRequest = function () {
    if (param && JSON.stringify(param) !== '{}') {
      let url = '/api/work_lines';
      let arr = [];
      Object.keys(param).forEach(key => {
        arr.push(key + '=' + param[key]);
      });
      if (arr.length !== 0) {
        url += '?' + arr.join('&');
      }
      exec(url);
    }
  };

  useEffect(() => {
    manualRequest();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [param]);

  return [data || {}, isRequestSuccessed, manualRequest];
});
